
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPPORT_USER = 'SUPPORT_USER',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  MANAGER = 'MANAGER',
  USER = 'USER'
}

export enum SubscriptionPlan {
  BASIC = 'BASIC',
  PRO = 'PRO',
  ENTERPRISE = 'ENTERPRISE'
}

export enum AppointmentType {
  PHONE = 'PHONE',
  VIDEO = 'VIDEO',
  PHYSICAL = 'PHYSICAL'
}

// TYPES POUR LA TIMELINE
export enum LeadActivityType {
  CREATED = 'CREATED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  ASSIGNED = 'ASSIGNED',
  COMMENT_ADDED = 'COMMENT_ADDED',
  INFO_UPDATED = 'INFO_UPDATED',
  APPOINTMENT_CREATED = 'APPOINTMENT_CREATED',
  EMAIL_SENT = 'EMAIL_SENT',
  CALL_LOGGED = 'CALL_LOGGED',
  FAVORITE_TOGGLED = 'FAVORITE_TOGGLED'
}

export interface LeadActivity {
  id: string;
  leadId: string;
  userId: string;
  userName: string;
  type: LeadActivityType;
  description: string;
  metadata?: {
    oldValue?: string;
    newValue?: string;
    [key: string]: any;
  };
  createdAt: string;
}

// NOUVEAUX TYPES POUR LES NOTIFICATIONS
export enum NotificationType {
  LEAD_ASSIGNED = 'LEAD_ASSIGNED',
  APPOINTMENT_REMINDER = 'APPOINTMENT_REMINDER',
  LEAD_INACTIVE = 'LEAD_INACTIVE',
  NEW_COMMENT = 'NEW_COMMENT',
  STATUS_CHANGED = 'STATUS_CHANGED',
  MENTION = 'MENTION',
  APPOINTMENT_CREATED = 'APPOINTMENT_CREATED',
  TASK_DUE_SOON = 'TASK_DUE_SOON'
}

export interface Notification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  leadId?: string;
  leadName?: string;
  isRead: boolean;
  createdAt: string;
  metadata?: {
    [key: string]: any;
  };
}

export interface PlanConfig {
  id: string;
  label: string;
  priceMonthly: number;
  priceYearly: number;
  userLimit: number;
  features?: string[];
}

export interface CurrencyConfig {
  code: string;
  name: string;
  symbol: string;
}

export interface SystemConfig {
  plans: PlanConfig[];
  currencies: CurrencyConfig[];
  activitySectors?: string[];
}

export interface Company {
  id: string;
  name: string;
  plan: string;
  userLimit: number;
  activeLeads: number;
  status: 'active' | 'suspended';
  createdAt: string;
  address?: string;
  rcs?: string;
  siret?: string;
  phone?: string;
  email?: string;
  website?: string;
  currency?: string;
  theme?: 'light' | 'dark';
  revenueBrackets?: string[];
  revenueColors?: Record<string, string>;
  cardBgColor?: string;
  cardNameColor?: string;
  cardEmailColor?: string;
  cardBgColorLight?: string;
  cardNameColorLight?: string;
  cardEmailColorLight?: string;
  maskContacts?: boolean;
  customFieldDefinitions?: CustomFieldDefinition[];
}

export type CustomFieldType = 'text' | 'number' | 'date' | 'select' | 'checkbox';

export interface CustomFieldDefinition {
  id: string;
  name: string;
  type: CustomFieldType;
  required?: boolean;
  options?: string[]; // pour type 'select'
}

export interface User {
  id: string;
  companyId: string;
  name: string;
  email: string;
  role: UserRole;
  avatar?: string;
  managerId?: string;
}

export interface Lead {
  id: string;
  companyId: string;
  clientCompanyName?: string;
  tag?: string;
  sectorActivity?: string;
  name: string;
  email: string;
  phone: string;
  status: 'new' | 'contacted' | 'qualified' | 'lost' | 'won';
  assignedTo: string;
  createdAt: string;
  additionalInfo?: string;
  potentialRevenue?: string;
  isFavorite?: boolean;
  source?: string;
  erpCustomerId?: string;
  customFields?: Record<string, any>;
}

export interface Appointment {
  id: string;
  leadId: string;
  userId: string;
  title: string;
  description: string;
  start: string;
  end: string;
  type: AppointmentType;
  clientEmail?: string;
}

export interface LeadComment {
  id: string;
  leadId: string;
  userId: string;
  userName: string;
  content: string;
  createdAt: string;
}

export interface OpportunityItem {
  id: string;
  opportunityId: string;
  label: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

export interface Opportunity {
  id: string;
  companyId: string;
  leadId?: string;
  clientCompanyName: string;
  subject: string;
  comment?: string;
  totalAmount: number;
  createdBy: string;
  createdAt: string;
  items: OpportunityItem[];
}

export type TaskStatus = 'todo' | 'done';

export interface Task {
  id: string;
  companyId: string;
  leadId?: string;
  clientCompanyName?: string;
  title: string;
  comment?: string;
  dueAt: string;
  status: TaskStatus;
  createdBy: string;
  createdAt: string;
  updatedAt?: string;
  completedAt?: string;
}

export interface CallStat {
  userId: string;
  callCount: number;
  avgDuration: number;
  totalDuration: number;
  period: 'day' | 'week' | 'month';
}
